import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Rich copy for the Analytics mission “connect” step — path to Project Settings only.
 */
export function AnalyticsConnectTourBody() {
  return (
    <div className="atlas-tour-step-body">
      <p style={{ margin: 0, fontSize: 14, lineHeight: 1.55, opacity: 0.95 }}>
        Analytics reads Jira worklogs. Go to <strong>Settings</strong> in the header, open the{' '}
        <Link className="atlas-tour-inline-link" to="/settings?tab=project">
          Project Settings
        </Link>{' '}
        tab, then set the <strong>organization Jira account</strong> and this product&apos;s{' '}
        <strong>Jira project key</strong>.
      </p>
    </div>
  );
}
